<template>
  <div class="or-cookie__bg">
    <div class="or-cookie__settings" v-if="tstringsReady">
      <div class="or-cookie__close" v-on:click="toggleSettings">{{tstrings.KOKUAPP.CLOSE}}</div>
      <h1>{{tstrings.KOKUAPP.CENTER_FOR_PRIVACY}}</h1>

      <div class=" or-cookie__items">
        <cookieitem v-for="(index, item) in data" :data.sync="item" :index="index" :tstrings.sync="tstrings"></cookieitem>
      </div>
      <button class="or-cookie__save" v-on:click="saveSettings">{{tstrings.KOKUAPP.SAVE_SETTINGS}}</button>
    </div>
  </div>
</template>

<script>
import cookieShared from './cookie-shared.js'
import cookieitem from './cookie-item.vue'

export default {
  name: 'cookie-settings',
  props: ['data'],
  mixins: [cookieShared],

  data () {
    return {
      tstrings: {},
      tstringsReady: false
    }
  },

  components: {
    cookieitem
  },

  events: {
    'content-visible' (index) {
      this.$broadcast('selectedIndex', index)
    },

    'language-set' (obj) {
      this.tstrings = obj
      this.tstringsReady = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// cookie-settings.vue?1b3d2a04